import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';

import CatalogCategory from './catalog-category/catalog-category';
import { CatalogCategoryFragment } from './catalog-navigation.graphql';

import defaultStyles from './catalog-navigation.scss';

interface Props {
    styles: typeof defaultStyles;
    mini?: boolean;
    hideNotSelected?: boolean;
    categoriesByParent: Map<string, NonNullable<CatalogCategoryFragment['edges']>>;
    initialActiveCategoryPosition: number[];
    categories: string[][];
    parentCategories?: boolean;
}

interface State {
    activeCategoryPosition: number[];
}

class CatalogNavigation extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { activeCategoryPosition: this.props.initialActiveCategoryPosition };
    }

    onClick = (columnIndex: number, rowIndex: number) => {
        const { activeCategoryPosition } = this.state;
        if (
            activeCategoryPosition.length === 2 &&
            activeCategoryPosition[0] === columnIndex &&
            activeCategoryPosition[1] === rowIndex
        ) {
            this.setState({
                activeCategoryPosition: [],
            });
        } else {
            this.setState({
                activeCategoryPosition: [columnIndex, rowIndex],
            });
        }
    };

    render() {
        const { styles, mini, categoriesByParent, categories, parentCategories, hideNotSelected } = this.props;
        const { activeCategoryPosition } = this.state;

        return (
            <ul
                className={classnames(mini ? styles.catalogListMini : styles.catalogList, {
                    [styles.noParentCategories]: !parentCategories,
                })}
            >
                {categories
                    ? categories.map((column, columnIndex) => (
                          <li
                              key={columnIndex}
                              className={classnames(mini ? styles.catalogItemMini : styles.catalogItem)}
                          >
                              {column.map((item, rowIndex) => {
                                  const selected =
                                      activeCategoryPosition.length === 2 &&
                                      activeCategoryPosition[0] === columnIndex &&
                                      activeCategoryPosition[1] === rowIndex;

                                  return categoriesByParent.get(item) ? (
                                      <CatalogCategory
                                          key={rowIndex * 10 + columnIndex}
                                          title={item}
                                          edges={categoriesByParent.get(item)!}
                                          selected={Boolean(selected)}
                                          hideNotSelected={Boolean(hideNotSelected)}
                                          onClick={() => this.onClick(columnIndex, rowIndex)}
                                          mini={Boolean(mini)}
                                          parentCategories={Boolean(parentCategories)}
                                      />
                                  ) : null;
                              })}
                          </li>
                      ))
                    : null}
            </ul>
        );
    }
}

export default Styled(defaultStyles)(CatalogNavigation);
